<mat-radio-group darkModeSupport color="primary">
  @for (option of options; track option) {
    <mat-card
      class="hoverable"
      (click)="radioButton._onTouchTargetClick($event)"
      [ngClass]="{ highlight: option.value === value, disabled: option.disabled }"
    >
      <mat-radio-button
        #radioButton
        (change)="radioChange($event)"
        [value]="option.value"
        [disabled]="option.disabled"
      ></mat-radio-button>
      <mat-icon>{{ option.icon }}</mat-icon>
      <p class="label">{{ option.label }}</p>
    </mat-card>
  }
</mat-radio-group>
